import Button from "components/Button";
import { SharedFlowState } from "components/Flow/types";
import Form from "components/Form";
import Label from "components/Label";
import segment from "lib/segment";
import React, { FC } from "react";
import toast from "react-hot-toast";
import { useRecoilState } from "recoil";
import { formatErrors, hasAddressAttirbute, required } from "utils/form";

import styles from "./styles.module.scss";

type Props = {
  sharedFlowState: SharedFlowState;
  nextStep(): void;
};

type FormValues = {
  address: string;
};

const SignUp: FC<Props> = ({ sharedFlowState, nextStep }) => {
  const [state, setState] = useRecoilState(sharedFlowState);

  return (
    <div className={styles.container}>
      <Label className={styles.title} color="primary2" variant="h4-centered">
        Let’s start with the basics, where is your home?
      </Label>
      <Label
        className={styles.subtitle}
        variant="body-centered"
        color="primary2"
      >
        With Humming Homes, we pair you with a local expert, and we&apos;re live
        in Greenwich County, Fairfield County, Westchester County, and the
        Hamptons.
      </Label>
      <Form
        initialValues={state}
        onError={(errors) =>
          toast.error(formatErrors(errors), { position: "top-right" })
        }
        className={styles.form}
        onSubmit={(values: FormValues) => {
          segment.track("LeadFlowAddressSubmitted", values);
          setState({ ...state, ...values });
          nextStep();
        }}
        fields={[
          {
            type: "location",
            id: "address",
            placeholder: "Your address",
            validate: [
              required("Address field is required"),
              hasAddressAttirbute(["zip"], "Invalid address, missing zip code"),
              hasAddressAttirbute(["city"], "Invalid address, missing city"),
              hasAddressAttirbute(["state"], "Invalid address, missing state")
            ]
          }
        ]}
      >
        {({ invalid }) => (
          <Button
            type="submit"
            animated={false}
            className={styles.submit}
            disabled={invalid}
            variant="accent"
          >
            Continue
          </Button>
        )}
      </Form>
    </div>
  );
};

export default SignUp;
